
eval("define(\'text!orodatagrid/templates/board/column-header-view.html\',[],function () { return \'<%= label %>\\n\';});\n\n//# sourceURL=/text!orodatagrid/templates/board/column-header-view.html");

